import { Segmented } from "antd";
import React from "react";

const SegmentedOption = ({ optionsList, option, setOption }) => {
  // Segmented Options onChange
  const onChange = (value) => {
    setOption(value);
  };
  return <Segmented options={optionsList} value={option} onChange={onChange} />;
};

export default SegmentedOption;
